export const HOMEPAGE = "/";
export const EVENTSPAGE = "/events";
export const TICKETSPAGE = "/ticket/";
export const CHECKOUTPAGE = "/checkout";
export const PRE_CHECKOUTPAGE = "/pre-checkout";
export const CONFIRMBOOKING = "/Confirm-booking";
export const MYBOOKINGS = "/bookings";
export const REDIRECTING = "/redirecting"
export const AUTH = "/"
